
  import { useIntegrationDetailsStore } from '@/stores/integrationDetails';
  import CombinedButton from './CombinedButton.vue';
  import ConfigureButton from './ConfigureButton.vue';
  import { computed, defineComponent } from 'vue';

  export default defineComponent({
    components: {
      CombinedButton,
      ConfigureButton,
    },
    setup() {
      const store = useIntegrationDetailsStore();
      const isActivated = computed(() => store.isActivated && store.integration?.enabled);

      return {
        isActivated,
      };
    },
  });
